import { useEffect, useRef, useState } from 'react';
import { Item as ListItem, useListState } from 'react-stately';
import { useAutocompleteSearchQuery } from '#domains/search';
import { ComboboxContext } from './context';

export const ComboboxProvider = ({ children }: React.PropsWithChildren) => {
  const { data } = useAutocompleteSearchQuery();
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);

  const listState = useListState({
    items: data?.items ?? [],
    children: item => <ListItem key={item.id}>{item.title}</ListItem>
  });

  const state = {
    ...listState,
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore
  useEffect(() => {
    listState.selectionManager.setFocusedKey(null);
  }, [data?.items]);

  return (
    <ComboboxContext.Provider value={{ state, triggerRef }}>
      {children}
    </ComboboxContext.Provider>
  );
};
